// 受付の送信。
//
// 返るのは受け付けたかどうかだけ（採番された Id も内容も返らない）。
// 400/500 は「送信できなかった」として同じ扱いにする — 客に出せる情報が無いため。

export interface EntryPayload {
  kind: number
  siteInfoId: number
  productCode: number
  productName: string
  quantity: number | null
  name: string
  email: string
  tel: string
  company: string
  note: string
  /** ハニーポット。人が触らない欄なので、通常は空のまま送る。 */
  website: string
}

export async function postEntry(api: string, payload: EntryPayload): Promise<boolean> {
  const r = await fetch(api, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(payload),
  })
  if (!r.ok) return false
  const d = await r.json().catch(() => null)
  return !!(d && d.ok)
}

/**
 * 商品管理番号 → 商品名（Issue #22）。?p=管理番号 で商品を受けたときだけ呼ぶ。
 * 引けなければ null（404 も通信エラーも同じ扱い。ウィジェットは描画しないだけ）。
 * `api` は受付と同じベース（…/api/stock-shortage）。
 */
export async function fetchProductName(api: string, siteInfoId: number, productCode: number): Promise<string | null> {
  try {
    const r = await fetch(`${api}/product?siteInfoId=${siteInfoId}&productCode=${productCode}`)
    if (!r.ok) return null
    const d = await r.json().catch(() => null)
    const name = d && d.ok && typeof d.productName === 'string' ? d.productName.trim() : ''
    return name === '' ? null : name
  } catch {
    return null
  }
}
